import styled from "styled-components";

export const BackButton = styled.button`
  display: inline-block;
  margin: auto;
  background: transparent;
  font: inherit;
  border: 0;
  outline: 0;
  padding: 0;
  transition: all 100ms ease-in;
  cursor: pointer;
  background: #a8967d;
  color: #fff;
  box-shadow: 0 0 10px 2px rgb(0 0 0 / 10%);
  border-radius: 2px;
  padding: 12px 36px;
  margin-bottom: 1.5em;

  &:hover {
    opacity: 0.7;
  }

  &:active {
    opacity: 0.9;
  }

  &:disabled {
    background: #dddddd;
    cursor: initial;
  }
`;
